import React from "react";

import css from "./Switch.module.css";

import cn from "classnames";

type SwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    size?: "small" | "medium";
    disabled?: boolean;
};

export const Switch: React.FC<SwitchProps> = ({
    checked,
    onChange,
    size = "medium",
    disabled = false,
}) => {
    return (
        <div
            className={cn(css.main, size === "small" && css.small, disabled && css.disabled)}
            onClick={() => onChange(!checked)}
        >
            <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
            <span className={css.switch}></span>
        </div>
    );
};
